import * as styles from "./conditionDisplayManager.module.scss";
export class ConditionDisplayManager {
    getHeaderClass() {
        return styles["condition-display"];
    }
    shouldDisplayPortLabels() {
        return true;
    }
    getHeaderText(nodeData) {
        return nodeData.data.name;
    }
    getBackgroundColor() {
        return "";
    }
    updatePreviewContent(nodeData, contentArea) { }
}
//# sourceMappingURL=conditionDisplayManager.js.map